<template>
  <div id="RedirectTree">
    <div class="menu-box" >
      <p class="menu-title">GET CONNECTED</p>

      <div class="menu-item-bar" @click="menuActions('https://barkbadge.com')">
        <span class="icon-text">
          <span class="img-container">
            <img src="@/assets/logo.svg"/>
          </span>
          barkbadge.com
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name: 'RedirectTree',
    methods:{
      menuActions(link){
        window.open(link)
      }
    }
  }
</script>
<style scoped>
#RedirectTree{
  margin: auto;
  padding: 1rem;
  max-width: 900px;
  background-color: #F6F5FB;
  min-height: 90vh;
  position: relative;
  padding-bottom: 10rem;
}
.menu-box{
  width: 80%;
  margin: .5rem auto;
}
.menu-item-bar{
  background-color: #fff;
  border-radius: 10px;
  width: 90%;
  max-width: 600px;
  font-size: 1rem;
  display: flex;
  /* flex-direction: row; */
  justify-content: space-between;
  align-items: center;
  margin: .5rem auto;
  transition: 1s;
  padding: .6rem;
  cursor:pointer;
}
.menu-item-bar:hover{
  transform: translateY(-10px);
}
.img-container{
  width: 1.4rem;
  height: 1.4rem;
  padding: .5rem;
  margin-right: 1.5rem;
  background-color: transparent;
  transition:1s;
}
.icon-text{
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.icon-text img{
  width: 1.8rem;
  height: 1.8rem;
}
.menu-title{
  color: var(--primary);
}
</style>
